<div class="grid flex justify-content-end social-summary-row">
  <div class="col-fixed flex justify-content-end align-items-center" style="gap: 20px">
          <span *ngIf="post?.reactionsCount" class="link inline-flex align-items-center" style="gap: 5px">
            <app-social-reactions-bar (click)="openSocialModal($event, post)" [reactions]="post?.reactions || []"></app-social-reactions-bar>
            <a (click)="openSocialModal($event, post)">
              {{ ('common.likes' | translate) + ': ' + (post?.reactionsCount || 0) }}
            </a>
          </span>
    <span *ngIf="post?.commentsCount" class="link">
                    <a (click)="onCommentBoxOpen(post)"
                    >{{ ('common.comments' | translate) + ': ' + (post?.commentsCount || 0) }}</a>
          </span>
    <span *ngIf="post?.sharesCount" class="link">
                    <a>{{ ('common.shares' | translate) + ': ' + (post?.sharesCount || 0) }}</a>
          </span>
  </div>
</div>
<p-divider styleClass="p-0 m-0 my-2 social-actions-divider-top" type="solid"></p-divider>
<p-menu #shareMenu [popup]="true" [model]="shareMenuItems" appendTo="body"></p-menu>
<div class="grid mx-0 social-action-buttons-row">
  <div class="col-12 flex justify-content-center p-0 m-0 mb-1 mt-1 pt-1">
    <div class="p-button-group" style="width: 100%; position: relative">
      <app-speed-dial #tileSpeedDial [model]="items" direction="right"></app-speed-dial>
      <button *ngIf="post?.currentUserReaction && post?.currentUserReaction?.reactedWith !== ReactedWithEnum.THUMBS_UP"
              pButton type="button"
              class="p-button-text p-button-rounded text-center justify-content-center align-items-center flex-auto"
              [ngClass]="{'p-button-plain': !post?.currentUserReaction, 'p-button-primary': post?.currentUserReaction}"
              style="width: 33.33%; font-size: 0.8em; max-height: 32px"
              ngxLongPress2
              (onLongPress)="toggleReactionBtn($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (click)="toggleThumbsUp($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (contextmenu)="false"
      >
        <ngx-emoji [emoji]="post?.currentUserReaction?.reactedWith|reactionClassMap" size="16"></ngx-emoji><span class="ml-2">{{('common.reaction.' + (post?.currentUserReaction?.reactedWith || '').toLowerCase())|translate}}</span>
      </button>
      <button *ngIf="post && (!post?.currentUserReaction || post?.currentUserReaction?.reactedWith === ReactedWithEnum.THUMBS_UP)"
              pButton type="button" [label]="(post?.currentUserReaction ? 'common.reaction.thumbs_up' : 'common.like_it') | translate|translateSelector:  'c'"
              class="p-button-text p-button-rounded text-center justify-content-center flex-auto"
              [ngClass]="{'p-button-plain': !post?.currentUserReaction, 'p-button-primary': post?.currentUserReaction}"
              style="width: 33.33%; font-size: 0.8em"
              icon="pi pi-thumbs-up"
              ngxLongPress2
              (onLongPress)="toggleReactionBtn($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (click)="toggleThumbsUp($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (contextmenu)="false"
      ></button>
      <button pButton type="button" [label]="'common.comment' | translate | ucfirst"
              (click)="onCommentBoxOpen(post)"
              [disabled]="preloadedComments"
              class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
              style="width: 33.33%; font-size: 0.8em"
              icon="pi pi-comments"></button>
      <button pButton type="button" [label]="'common.share' | translate"
              class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
              style="width: 33.33%; font-size: 0.8em"
              (click)="openShareMenu($event)"
              icon="pi pi-share-alt"></button>
    </div>
  </div>
</div>
<app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
<ng-container *ngIf="isCommentBoxOpened || preloadedComments">
  <p-divider styleClass="p-0 m-0 my-2 social-actions-divider-bottom" type="solid"></p-divider>
  <div *ngIf="!isMobileView()" class="col-12 py-3 px-0 m-0 mt-1 pt-1 social-input-sticky">
    <app-social-input [typingChannel]="post?.id ? 'typing_comments:' + post.id : null" (submitted)="onCommentSubmit($event, post)"
                      [imageOnly]="true" [allowEmptySubmit]="true"
                      [label]="getBottomInputLabel()"></app-social-input>
  </div>
  <div
    class="grid mx-0 input-overflow-y social-comments-layout"
    [class.social-comments-layout--collapsed]="comments.length > 1 && !isThreadListOpened"
    overflow-y
  >
    <div *ngIf="comments.length > 1" class="inline-flex justify-content-start mb-2 social-comments-toggle" style="width: 100%; gap: 20px;">
      <a *ngIf="!isThreadListOpened" (click)="toggleThreadList()">
        {{ 'common.show_all_comments' | translate }} ({{ comments.length }})</a>
      <a *ngIf="isThreadListOpened" (click)="toggleThreadList()">{{ 'common.hide_comments' | translate }}</a>
    </div>
    <div class="col-12 p-0 m-0 social-fixed-height social-comments-scroll-area" (click)="onConversationTap()">
      <ng-container *ngIf="post?.commentsCount && !commentBoxLoaded">
        <p-skeleton styleClass="mb-2" borderRadius="16px"></p-skeleton>
        <p-skeleton width="10rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
        <p-skeleton width="5rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
        <p-skeleton height="2rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
        <p-skeleton width="10rem" styleClass="mb-3" height="4rem" borderRadius="16px"></p-skeleton>
      </ng-container>
      <ng-container *ngIf="comments.length && commentBoxLoaded">
        <div class="comment thread mb-0 content-overflow-y">
          <div *ngFor="let comment of comments.slice(0, isThreadListOpened ? comments.length : 1)" class="mb-2">
            <div class="grid grid-nogutter">
              <div class="col-12 inline-flex">
                <a [routerLink]="comment.author?.slug ? ['/' + comment.author.slug, 'garage'] : null" style="height: 36px">
                  <app-thumbnail
                    classList="thumbnail-inline-block mr-2"
                    size="md"
                    [circle]="true"
                    [imgSrc]="comment.author.avatar | mediaObject"
                  ></app-thumbnail>
                </a>
                <div class="grid grid-nogutter" style="width: 100%">
                  <div class="col-11">
                    <a [routerLink]="comment.author?.slug ? ['/' + comment.author.slug, 'garage'] : null">{{ comment.author.username }}</a>
                    <span class="block" [innerHTML]="comment.content | sanitizeHtml"></span>
                    <app-comment-media [media]="comment.media"></app-comment-media>
                  </div>
                  <div class="col-1 flex justify-content-end">
                    <app-end-cap
                      *ngxPermissionsOnly="[comment.author | ownerRole]"
                      icon="pi pi-ellipsis-h"
                      [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
                      (onClickTrigger)="emitCommentContextMenuOpen(comment)"
                    >
                    </app-end-cap>
                  </div>
                  <div *ngIf="comment.responses.length > 1" class="col-12 inline-flex justify-content-start mb-2"
                       style="width: 100%; gap: 20px;">
                    <a *ngIf="!isItemOpened(isThreadCommentListOpened, comment)"
                       (click)="toggleThreadCommentsMap(comment)">{{ 'common.show_all_comments' | translate }}
                      ({{ comment.responses.length }})</a>
                    <a *ngIf="isItemOpened(isThreadCommentListOpened, comment)"
                       (click)="toggleThreadCommentsMap(comment)">{{ 'common.hide_comments' | translate }}</a>
                  </div>
                  <div class="col-12 inline-flex justify-content-start  mb-2" style="width: 100%; gap: 20px;">
                    <a>{{ comment.createdAt | dateAgo }}</a>
                    <app-speed-dial #commentSpeedDial [model]="items" direction="right"></app-speed-dial>
                    <a
                      ngxLongPress2
                      (onLongPress)="toggleReactionBtn($event, comment, ReactionTypeEnum.COMMENT_REACTION, commentSpeedDial)"
                      (click)="toggleThumbsUp($event, comment, ReactionTypeEnum.COMMENT_REACTION, commentSpeedDial)"
                      (contextmenu)="false"
                    >
                          <span *ngIf="comment.currentUserReaction" class="inline-flex align-items-center">
                            <span (click)="openSocialModal($event, comment)" class="mr-2">{{comment.reactions.length}}</span>
                            <ngx-emoji [emoji]="comment.currentUserReaction.reactedWith|reactionClassMap" size="12.8"></ngx-emoji>
                          </span>
                      <span *ngIf="!comment.currentUserReaction">{{ 'common.like' | translate }}</span>
                    </a>
                    <a (click)="onReplyClick($event, comment)">
                      {{ 'common.reply' | translate }}</a>
                  </div>
                  <ul *ngIf="comment.responses.length" class="col-12 comment">
                    <li
                      *ngFor="let reply of comment.responses.slice(isItemOpened(isThreadCommentListOpened, comment) ? 0 : comment.responses.length -1, comment.responses.length)">
                      <div class="grid grid-nogutter">
                        <div class="col-12 inline-flex">
                          <a [routerLink]="reply.author?.slug ? ['/' + reply.author.slug, 'garage'] : null" style="height: 36px">
                            <app-thumbnail
                              classList="thumbnail-inline-block mr-2"
                              size="md"
                              [circle]="true"
                              [imgSrc]="reply.author.avatar | mediaObject"
                            ></app-thumbnail>
                          </a>
                          <div class="grid grid-nogutter" style="width: 100%">
                            <div class="col-11">
                              <a [routerLink]="reply.author?.slug ? ['/' + reply.author.slug, 'garage'] : null">{{ reply.author.username }}</a>
                              <span class="block" [innerHTML]="reply.content | sanitizeHtml"></span>
                              <app-comment-media [media]="reply.media"></app-comment-media>
                            </div>
                            <div class="col-1 flex justify-content-end">
                              <app-end-cap
                                *ngxPermissionsOnly="[reply.author | ownerRole]"
                                icon="pi pi-ellipsis-h"
                                [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
                                (onClickTrigger)="emitCommentContextMenuOpen(reply)"
                              >
                              </app-end-cap>
                            </div>
                            <div class="col-12 inline-flex justify-content-start mb-2"
                                 style="width: 100%; gap: 20px;">
                              <a>{{ reply.createdAt | dateAgo }}</a>
                              <app-speed-dial #replySpeedDial [model]="items" direction="right"></app-speed-dial>
                              <a
                                ngxLongPress2
                                (onLongPress)="toggleReactionBtn($event, reply, ReactionTypeEnum.COMMENT_REACTION, replySpeedDial)"
                                (click)="toggleThumbsUp($event, reply, ReactionTypeEnum.COMMENT_REACTION, replySpeedDial)"
                                (contextmenu)="false"
                              >
                                    <span *ngIf="reply.currentUserReaction" class="inline-flex align-items-center">
                                      <span (click)="openSocialModal($event, reply)" class="mr-2">{{reply.reactions.length}}</span>
                                      <ngx-emoji [emoji]="reply.currentUserReaction.reactedWith|reactionClassMap" size="12.8"></ngx-emoji>
                                    </span>
                                <span *ngIf="!reply.currentUserReaction">{{ 'common.like' | translate }}</span>
                              </a>
                              <a (click)="onReplyClick($event, comment, reply)">{{ 'common.reply' | translate }}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div *ngIf="!isMobileView() && isItemOpened(isThreadCommentInputOpened, comment)" class="col-12">
                    <app-social-input [typingChannel]="post?.id ? 'typing_comments:' + post.id : null" style="width: 100%"
                                      [imageOnly]="true" [allowEmptySubmit]="true"
                                      (submitted)="onReplySubmit($event, post, comment)"
                                      [label]="getReplyInputLabel(comment)"
                    ></app-social-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!comments.length && commentBoxLoaded">
        <div class="social-comments-empty">
          <i class="pi pi-comments social-comments-empty__icon"></i>
          <div class="social-comments-empty__title">{{ 'common.no_comments_yet' | translate }}</div>
          <div class="social-comments-empty__subtitle">{{ 'common.write_first_comment' | translate }}</div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="isMobileView()" class="col-12 py-3 px-0 m-0 mt-1 pt-1 social-input-sticky">
      <app-social-input [typingChannel]="post?.id ? 'typing_comments:' + post.id : null" (submitted)="onCommentSubmit($event, post)"
                        [imageOnly]="true" [allowEmptySubmit]="true"
                        [label]="getBottomInputLabel()"></app-social-input>
    </div>
  </div>
</ng-container>
